import React from "react";
import { Route, Routes } from "react-router-dom";
import CrewMemberSecureAssets from "../containers/SecureAssets/CrewMemberSecureAssets";

export const SecureAssetsRoutes = () => (
  <Routes>
    <Route path="/cm" element={<CrewMemberSecureAssets />} />
  </Routes>
);
